import { useState, useEffect } from 'react';

const useMediaQuery = (query: string): boolean => {
	const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);
		const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);

		setMatches(mediaQuery.matches);
		mediaQuery.addEventListener('change', handleChange);
		return () => mediaQuery.removeEventListener('change', handleChange);
	}, [query]);

	return matches;
};

export { useMediaQuery };
export default useMediaQuery;
